import { IObjectsControllable } from "./IObjectsControllable";
import { ILinkedPageObjectSpecifiable } from "./ILinkedPageObjectSpecifiable";

export interface IItemSelectTriggerBehaviorSpecifiable {
  itemSelectTriggerBehavior: IObjectsControllable<ILinkedPageObjectSpecifiable>;
}

export function instanceOfIItemSelectTriggerBehaviorSpecifiable(instance: any): instance is IItemSelectTriggerBehaviorSpecifiable {
  return instance
      && (instance.itemSelectTriggerBehavior !== undefined);
}
